import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personalized-card-orders',
  templateUrl: './personalized-card-orders.component.html',
  styleUrls: ['./personalized-card-orders.component.scss']
})
export class PersonalizedCardOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
